export default __webpack_public_path__ + "media/images/Symbol_Check-60511d834f111e1252162fd43eb0ad85.png";